import React from 'react';
import ExternalLink from 'shared/components/Links/ExternalLink';

const COMPLIANCE_LINK = 'https://drive.google.com/open?id=1To45hOWbPLOt6CYtdzkJmPFo2Gb4CNu_';

const SwitchComplianceLink = () => <ExternalLink to={COMPLIANCE_LINK}>LAUNCHPAD SWITCH COMPLIANCE FORM</ExternalLink>;

export default SwitchComplianceLink;
